// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pg_a bhe_ea bhe_kb bhe_js bhe_a bhe_j bhe_sm bhe_sn","SearchPanel__icon":"pg_b bhe_vm bhe_hg bhe_ss bhe_uy","SearchPanel__input":"pg_c bhe_iz bhe_eb bhe_z"};